<div class="footer-container" [ngStyle]="footerStyle" (click)="toggle()">
  @if (!shown) {
    <div class="footer-show" ngbTooltip="Show environment params" placement="top"><fa-icon icon="chevron-up" size="lg"></fa-icon></div>
  }
  @if (shown) {
    <div class="footer-show" ngbTooltip="Hide environment params" placement="top"><fa-icon icon="chevron-down" size="lg"></fa-icon></div>
  }
</div>
@if (shown) {
  <div class="footer-container">
    @if (shown) {
      <div class="footer-content" fxLayout="row">
        @if (onesosuiSettings) {
          <div class="info-group info-spacing" fxLayout="column" popoverTitle="Last commit {{onesosuiSettings.gitCommitTime | date: 'dd-MM-yyyy HH:mm:ss'}}" [ngbPopover]="onesosuiSettings.gitCommitMessage" triggers="mouseenter:mouseleave">
            <div class="info-name">{{onesosuiSettings.buildName}}</div>
            <div class="info-value">{{onesosuiSettings.buildVersion}}</div>
          </div>
        }
        @if (onesosGuidelineSettings) {
          <div class="info-group info-spacing" fxLayout="column" popoverTitle="Last commit {{onesosGuidelineSettings.gitCommitTime | date: 'dd-MM-yyyy HH:mm:ss'}}" [ngbPopover]="onesosGuidelineSettings.gitCommitMessage" triggers="mouseenter:mouseleave">
            <div class="info-name">{{onesosGuidelineSettings.buildName}}</div>
            <div class="info-value">{{onesosGuidelineSettings.buildVersion}}</div>
          </div>
        }
        @if (caseManagementSettings) {
          <div class="info-group info-spacing" fxLayout="column" [ngbTooltip]="caseManagementSettings.gitCommitMessage" placement="top">
            <div class="info-name">{{caseManagementSettings.name}}</div>
            <div class="info-value">{{caseManagementSettings.version}}</div>
          </div>
        }
        @if (caseEconomyServiceSettings) {
          <div class="info-group info-spacing" fxLayout="column" [ngbTooltip]="caseEconomyServiceSettings.gitCommitMessage" placement="top">
            <div class="info-name">{{caseEconomyServiceSettings.name}}</div>
            <div class="info-value">{{caseEconomyServiceSettings.version}}</div>
          </div>
        }
        @if (onePointSettings) {
          <div class="info-group info-spacing" fxLayout="column" [ngbTooltip]="onePointSettings.gitCommitMessage" placement="top">
            <div class="info-name">{{onePointSettings.name}}</div>
            <div class="info-value">{{onePointSettings.version}}</div>
          </div>
        }
        @if (documentServiceSettings) {
          <div class="info-group info-spacing" fxLayout="column" [ngbTooltip]="documentServiceSettings.gitCommitMessage" placement="top">
            <div class="info-name">{{documentServiceSettings.name}}</div>
            <div class="info-value">{{documentServiceSettings.version}}</div>
          </div>
        }
      </div>
    }
  </div>
}
